import React from 'react'

const ButtonLoadMore = ({ onClick, value }) => {
  return (
    <button className="px-8 py-2 border rounded-sm border-black w-36 sm:w-48" onClick={()=>onClick(value)}>Load {value}</button>
  )
}

export default ButtonLoadMore